import styles from './Logo.module.scss';
export default function Logo() {
  return (
    <h2 className={styles.logo}>
      pe<span>t</span>ly
    </h2>
  );
}
